export default {
  cards: [],
  card: {},
  cardTypes: [],
  tasks: [],
  notifications: [],
  user: {},
  tenants: [],
};
